// extracted by mini-css-extract-plugin
export var completionBody = "_kh-2";
export var completionCard = "_kh-0";
export var completionFooter = "_kh-3";
export var completionTitle = "_kh-1";